// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IIkd","label":"styles_label__1YEAe"};